import { ROLES } from '../../../utils/roles.js';
import { M } from '../msg.js';
import { registerPageTour } from '../matchRoute.js';

registerPageTour({
  id: 'super-admin-dashboard',
  match: (p) => p === '/super-admin',
  steps: [
    {
      id: 'intro',
      selector: '[data-tour="page-title"]',
      title: M('Platform dashboard', 'Dashboard платформы'),
      body: M(
        'Viib-wide overview: organizations, subscriptions, and platform health. You manage all agencies from here.',
        'Обзор Viib: организации, подписки и здоровье платформы. Управление всеми агентствами.',
      ),
      roles: [ROLES.SUPER_ADMIN],
    },
    {
      id: 'stats',
      selector: '[data-tour="tour-dashboard-stats"]',
      title: M('Platform metrics', 'Метрики платформы'),
      body: M(
        'Total organizations, active subscriptions, and user counts. Drill into each section from the nav.',
        'Организации, подписки и пользователи. Детали — через навигацию.',
      ),
      roles: [ROLES.SUPER_ADMIN],
    },
  ],
});

registerPageTour({
  id: 'super-admin-plans',
  match: (p) => p === '/super-admin/plans',
  steps: [
    {
      id: 'intro',
      selector: '[data-tour="page-title"]',
      title: M('Subscription plans', 'Тарифные планы'),
      body: M(
        'Define what each agency plan includes: price, Stripe price ID, and feature flags that gate /admin capabilities.',
        'Цена, Stripe price ID и feature flags, которые открывают возможности /admin.',
      ),
      roles: [ROLES.SUPER_ADMIN],
    },
    {
      id: 'list',
      selector: '[data-tour="plans-list"]',
      title: M('Plan catalog', 'Каталог планов'),
      body: M(
        'Edit existing plans or create new tiers. Changes affect new subscriptions; existing subs keep until switched.',
        'Редактирование и новые тарифы. Новые подписки — сразу; текущие — до смены плана.',
      ),
      roles: [ROLES.SUPER_ADMIN],
    },
    {
      id: 'features',
      selector: '[data-tour="plans-features"]',
      title: M('Feature checkboxes', 'Чекбоксы features'),
      body: M(
        'Each flag maps to middleware and UI gates: integrations, asset hub, live chat, client tasks, etc.',
        'Каждый флаг — middleware и UI: интеграции, asset hub, live chat, client tasks и др.',
      ),
      roles: [ROLES.SUPER_ADMIN],
    },
  ],
});

registerPageTour({
  id: 'super-admin-organizations',
  match: (p) => p === '/super-admin/organizations',
  steps: [
    {
      id: 'intro',
      selector: '[data-tour="page-title"]',
      title: M('Organizations', 'Организации'),
      body: M(
        'Every agency tenant on the platform. Create orgs, assign plans, and impersonate admins for support.',
        'Каждое агентство на платформе. Создание, планы и impersonation для поддержки.',
      ),
      roles: [ROLES.SUPER_ADMIN],
    },
    {
      id: 'list',
      selector: '[data-tour="orgs-list"]',
      title: M('Organization table', 'Таблица организаций'),
      body: M(
        'See subscription status and owner. Open or use View as admin to troubleshoot inside /admin.',
        'Статус подписки и владелец. View as admin — отладка в /admin.',
      ),
      roles: [ROLES.SUPER_ADMIN],
    },
  ],
});

registerPageTour({
  id: 'super-admin-users',
  match: (p) => p === '/super-admin/users',
  steps: [
    {
      id: 'intro',
      selector: '[data-tour="page-title"]',
      title: M('All users', 'Все пользователи'),
      body: M(
        'Cross-tenant user search. Change roles carefully — super_admin grants full platform access.',
        'Поиск пользователей по платформе. super_admin — полный доступ к платформе.',
      ),
      roles: [ROLES.SUPER_ADMIN],
    },
    {
      id: 'filters',
      selector: '[data-tour="users-filters"]',
      title: M('Search & filter', 'Поиск и фильтр'),
      body: M(
        'Filter by role to audit admins or find a client login. Search matches name and email.',
        'Фильтр по роли. Поиск по имени и email.',
      ),
      roles: [ROLES.SUPER_ADMIN],
    },
    {
      id: 'table',
      selector: '[data-tour="users-table"]',
      title: M('User table', 'Таблица пользователей'),
      body: M(
        'Update role inline. View as user opens their portal experience for support tickets.',
        'Смена роли в строке. View as user — их опыт в портале.',
      ),
      roles: [ROLES.SUPER_ADMIN],
    },
  ],
});

registerPageTour({
  id: 'super-admin-clients',
  match: (p) => p === '/super-admin/clients',
  steps: [
    {
      id: 'intro',
      selector: '[data-tour="page-title"]',
      title: M('Cross-org clients', 'Клиенты всех org'),
      body: M(
        'Read-only index of client records across agencies — useful for support and data audits.',
        'Read-only индекс клиентов всех агентств — для поддержки и аудита.',
      ),
      roles: [ROLES.SUPER_ADMIN],
    },
    {
      id: 'list',
      selector: '[data-tour="clients-list"]',
      title: M('Client index', 'Индекс клиентов'),
      body: M(
        'Shows which organization owns each client. Agency staff manage details in their own /admin/clients.',
        'Какая org владеет клиентом. Детали — в /admin/clients агентства.',
      ),
      roles: [ROLES.SUPER_ADMIN],
    },
  ],
});
